import { Component, OnInit, OnDestroy , ElementRef, ViewChild, AfterViewInit} from '@angular/core';
import { Router } from '@angular/router';
import { process, State } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl } from '@angular/forms';
import { AccountService, ConstantsService, SessionService, EnvironmentService, RequestStageApprvEnum, LookupsService} from '@app/base/core';
import { LandingService } from '@app/modules/landing/base';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
import { AlertService } from '@app/base/alerts/alert.service';
import { BuilderService } from '@app/modules/builder';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-contract',
  templateUrl: './contract.component.html',
  styleUrls: ['./contract.component.css']
})
export class ContractComponent implements OnInit,  OnDestroy, AfterViewInit {
  ngAfterViewInit(): void {
    this.mySelection = [this.BcaId];
  }

  @ViewChild('ContractDiv', {static: false}) ctnD: ElementRef;
// Defining the Constructor
  constructor( private route: ActivatedRoute,
    private router: Router,
    private http: LandingService,
    public lookupSvc: LookupsService,
    public alertService: AlertService,
    public sessionSvc: SessionService,
    public constantsSVc: ConstantsService,
    public config: SocoConfigurationService,
    private accountService: AccountService,
    public builderSvc: BuilderService,
    public environmentSvc: EnvironmentService,
    ) {this.buildFormGroup();  }
  private routeSubscription: any;
// Declaring the Variables
  stageEnum: typeof RequestStageApprvEnum = RequestStageApprvEnum;
  BcaId: number;
  recordPresent = 0;
  public contractChecked;
  ContractInfo: string;
  public indexArr = [];
  alertMsg: any = [];
  ProjectName: string;
  Status: string;
  Pwr: string;
  isrowCount = false;
  public bcaData: any = [];
  contractForm: FormGroup;
  public mySelection: number[] = []; // Todo: DSS: review setting to BcaId on init
  public fileid: number;
  documentInput: any = {};
  public filesArr = [];
  // Declaring the Grid Size
  public state: State = {
    skip: 0,
    take: 8,

    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };


  public gridData: GridDataResult = process(this.bcaData, this.state);
  // Building the form group
  buildFormGroup(): void {
    this.contractForm = new FormGroup({
      chkDoc: new FormControl(false),
      BcaId: new FormControl('')
    },
    { updateOn: 'blur' });
  }
  ngOnInit() {

    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Contract'
        ));
        this.alertService.info(this.alertMsg.message);
      }
    });
     // Get ID and user from route params.
     this.routeSubscription = this.route.params.subscribe(params => {
      if (params['user']) {
        this.sessionSvc.sourceToContract = (params['user']);
      }
      if (!isNaN(Number(params['id']))) {
        this.BcaId = (params['id']);
        this.mySelection = [this.BcaId];
        this.contractForm.controls['BcaId'].patchValue(this.BcaId);
        if (this.sessionSvc.sourceToContract === this.constantsSVc.ApplicantUser) {
        this.GetContractInfoByEmail(this.accountService.account.user.email);
        } else {
          this.GetContractInfoById(this.BcaId);
        }
      }       else if (params['id'])      {
      this.GetContractInfoByEmail(this.accountService.account.user.email);

      } else {

        this.GetContractInfoByEmail(this.accountService.account.user.email);
      }
    });


  }
  ngOnDestroy() {
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridData = process(this.bcaData, this.state);
  }
// Grid selection of contract ID
  onCellClick(event)  {
    this.Status = event.dataItem.requestStatus;
    this.SelectedRow(event.dataItem);
  }
  GetContractInfoByEmail(email: string )  {
    this.http.getBcaContractInfoeMail(email).subscribe(result => {
      if (result.data != null) {
        for (let i = 0; i < result.data.length; i++) {
          if (result.data[i].contractSentDate != null) {
            result.data[i].contractSentDate = new Date(result.data[i].contractSentDate.toString());
          }
          if (result.data[i].contractReceivedDate != null) {
            result.data[i].contractReceivedDate = new Date(result.data[i].contractReceivedDate.toString());
          }
          this.bcaData.push(result.data[i]);
        }
        this.BcaId = result.data[0].bcaId;
        this.mySelection = [this.BcaId];
        this.ContractInfo = result.data[0].gasRequestType;
        this.ProjectName = result.data[0].projectName;
        this.Status = result.data[0].requestStatus;
        if (this.ctnD) {
        this.ctnD.nativeElement.style.display = 'block';
        }
        this.http.getPwrNumber(this.BcaId).subscribe(result => {
          this.Pwr = result.data.primaryWorkRequest;
          this.getDoc();
        });
      } else {
        if (this.ctnD) {
        this.ctnD.nativeElement.style.display = 'none';
        }
      }
      this.gridData = process(this.bcaData, this.state);

    },
    (error => {
      swal(this.constantsSVc.errorSwal1, this.constantsSVc.contractInfoFail, this.constantsSVc.errorSwal);
    }));

  }

  GetContractInfoById(id: number)  {
// Get the Grid Data
this.http.getBcaContractInfo(id).subscribe(result => {
  if (result.data != null) {
    for (let i = 0; i < result.data.length; i++) {
      if (result.data[i].contractSentDate != null) {
        result.data[i].contractSentDate = new Date(result.data[i].contractSentDate.toString());
      }
      if (result.data[i].contractReceivedDate != null) {
        result.data[i].contractReceivedDate = new Date(result.data[i].contractReceivedDate.toString());
      }
      this.bcaData.push(result.data[i]);
    }
    this.recordPresent = 1;
    this.BcaId = result.data[0].bcaId;
    this.mySelection = [this.BcaId];
    this.ContractInfo = result.data[0].gasRequestType;
    this.ProjectName = result.data[0].projectName;
    this.Status = result.data[0].requestStatus;
    if (this.ctnD) {
    this.ctnD.nativeElement.style.display = 'block';
    }
    this.http.getPwrNumber(this.BcaId).subscribe(result => {
      this.Pwr = result.data.primaryWorkRequest;
      this.getDoc();
    });
  } else {
    if (this.ctnD) {
    this.ctnD.nativeElement.style.display = 'none';
    }
  }
  this.gridData = process(this.bcaData, this.state);
},
(error) => {
  swal(this.constantsSVc.errorSwal1, this.constantsSVc.contractInfoFail, this.constantsSVc.errorSwal);
});
  }

  // Grid Selection row.
  SelectedRow(e)  {
    this.BcaId = e.bcaId;
    this.ContractInfo = e.gasRequestType;
    this.ProjectName = e.projectName;
    this.Status = e.requestStatus;
    this.http.getPwrNumber(this.BcaId).subscribe(result => {
      this.Pwr = result.data.primaryWorkRequest;
      this.getDoc();
    });
    this.contractForm.controls['chkDoc'].patchValue(false);
    return false;
  }

  // Checkbox checked event
  CheckedTrue(index, id) {
   if (this.indexArr.includes(index)) {
     const number = this.indexArr.indexOf(index);
     this.indexArr.splice(number, 1);
     return false;
   } else {
     this.indexArr.push(index);
     this.downloadDoc(id);
     return true;
   }

  }
// Navigate to Accept Contract
  goToAcceptContract() {

    if (this.filesArr.length === this.indexArr.length)    {
      this.sessionSvc.projectName = this.ProjectName;
      this.router.navigate([this.sessionSvc.paramLdc.toLocaleLowerCase(), 'builder', 'contractaccept', this.BcaId, this.ContractInfo]);

    }    else {
     swal(this.constantsSVc.contractSwal, '', this.constantsSVc.errorSwal);
    }
  }
  // Go To Back
  goToBack() {

    if (this.sessionSvc.sourceToContract === this.constantsSVc.ApplicantUser) {
      this.router.navigate([this.sessionSvc.paramLdc.toLocaleLowerCase(),  'status']);
    }    else {
      this.router.navigate([this.sessionSvc.paramLdc.toLocaleLowerCase(), 'builder', 'home']);

    }
  }
  // go To Payment page
  goToPayment() {
    this.sessionSvc.projectName = this.ProjectName;
      this.router.navigate([this.sessionSvc.paramLdc.toLocaleLowerCase(), 'builder', 'payment',
       this.sessionSvc.sourceToContract, this.BcaId]);

  }

  getDoc() {
    this.filesArr = [];
    this.documentInput.folder = this.constantsSVc.LaserficheContractFolder;
    this.documentInput.bcaId = String(this.BcaId);
    this.documentInput.WRNumber = String(this.Pwr);
    this.documentInput.Authoritative = 'Y';
    this.documentInput.ExternalCompany = 'Y';
    this.builderSvc.findFilesByMetadata(this.documentInput).subscribe(result => {
      if (result.data.length !== 0) {
        for ( let i = 0; i < result.data.length; i++) {
          this.filesArr.push(result.data[i]);
      }
      }
    },
    (error) => {
      swal(this.constantsSVc.headerDocReqSwal, this.constantsSVc.contractDocFailSwal, this.constantsSVc.errorSwal);
     } );
  }
  downloadDoc(id) {

      this.fileid = id;
      window.open(this.config.webApiBaseUrl + '/Files/Download?id=' + this.fileid, '_blank');

  }
}
